import React, { useEffect } from 'react'
import './layout.css'
import { Layout as AntLayout } from 'antd'

import Sider from '../sider/Sider'

const { Content, Footer } = AntLayout

function AppLayout({ children }) {
  const theme = localStorage.getItem('theme') || 'dark'

  useEffect(() => {
    document.body.classList.toggle('gps-theme-dark', theme === 'dark')
    document.body.classList.toggle('gps-theme-light', theme !== 'dark')

    return () => {
      document.body.classList.remove('gps-theme-dark', 'gps-theme-light')
    }
  }, [theme])

  return (
    <AntLayout className={`gps-app-layout gps-app-layout--${theme}`}>
      <Sider />
      <AntLayout className="gps-app-layout__body">
        <Content className="gps-app-content">{children}</Content>
        <Footer className="gps-app-footer">
          gpshistory.live ©2021
        </Footer>
      </AntLayout>
    </AntLayout>
  )
}

export default AppLayout
